import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {FaTwitter, FaTelegram} from "react-icons/fa";
import logoImage from "../../../assets/images/eggplant-logo-dark-full.png";
import binnaceImage from "../../../assets/images/logo-binance-long.svg";

const Footer = () => {
  return (
    <div className="footer">
      <div className="socialIcons">
        <a href="https://twitter.com/eggplant_fi" target="_blank">
          <FaTwitter />
        </a>
        <a href="https://t.me/Eggplant_Fi" target="_blank">
          <FaTelegram />
        </a>
      </div>
      <div className="logoImage">
        <img src={logoImage} />
      </div>
      <div className="binnaceImage">
        <img src={binnaceImage}/>
      </div>
    </div>
  )
}

export default Footer;